import { motion } from "framer-motion";

const rows = [
  {
    term: "Confusing",
    desc: "court forms and procedures most people never finish",
  },
  {
    term: "Slow",
    desc: "weeks of waiting just for a hearing date",
  },
  {
    term: "Costly",
    desc: "lawyers quoting $300 an hour for a $400 problem",
  },
  {
    term: "Lonely",
    desc: "you versus a company with a whole legal department",
  },
];

export const ProblemSection = () => (
  <section id="problem" data-testid="problem-section" className="py-16 sm:py-24">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.5 }}
        className="flex items-center gap-4 mb-8"
      >
        <span className="h-[3px] w-14 bg-[#2563EB]" />
        <span className="text-xs font-bold tracking-[0.35em] uppercase text-[#71717a]">
          The Problem
        </span>
      </motion.div>

      <motion.h2
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#111827] max-w-4xl"
      >
        An agreement breaks. A service fails. Money is owed.{" "}
        <span className="highlight-swash">Then what?</span>
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay: 0.15 }}
        className="mt-8 text-base sm:text-lg text-[#52525B] leading-relaxed max-w-2xl"
      >
        Every day, people and small businesses get cheated, overcharged, or
        ghosted by companies that count on you not fighting back. Not because
        you don&rsquo;t want to, but because the process is built to wear you
        down.
      </motion.p>

      <div className="mt-14">
        {rows.map((r, i) => (
          <motion.div
            key={r.term}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: i * 0.08 }}
            className="grid sm:grid-cols-[240px_1fr] gap-1 sm:gap-8 py-7 border-t border-[#E5E7EB] last:border-b"
          >
            <span className="font-display font-semibold text-2xl sm:text-3xl text-[#111827]">
              {r.term}
            </span>
            <span className="text-base sm:text-lg text-[#52525B] leading-relaxed max-w-md">
              {r.desc}
            </span>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
